import React from 'react';
import Avatar from '@atlaskit/avatar';
import EllipsedWithTooltip from '@atlassian/jira-portfolio-3-portfolio/src/common/view/ellipsed-with-tooltip/index.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

export default function TeamItem({ itemId, position, teamsById }: Props) {
	const team = teamsById[itemId];

	const width = 250;
	const height = 50;

	return (
		<div
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={styles.container}
			style={{
				top: position.y - height / 2,

				left: position.x - width / 2,
			}}
			role="button"
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onKeyDown={() => {}}
			onClick={(e) => {
				e.stopPropagation();
			}}
			tabIndex={0}
			data-testid={`portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.team-item-${team.id}`}
		>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.content}>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.avatar}>
					<Avatar size="small" src={team.avatarUrl} />
				</div>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.title}>
					<EllipsedWithTooltip content={team.title} id={team.id}>
						<span>{team.title}</span>
					</EllipsedWithTooltip>
				</div>
			</div>
		</div>
	);
}
